export const accessMemberQueryKey = ['access-member'] as const;
